@if (isVisible) {
    <div class="flex flex-col gap-2">
        <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
        <div class="flex flex-col items-center justify-center">
            @if (!isLoading && loadingSuccess) {
                @if (snapshotSummaries.length) {
                    <collection-snapshot-items-chart [snapshotSummaries]="snapshotSummaries" class="w-full"></collection-snapshot-items-chart>
                    <collection-snapshot-value-chart [snapshotSummaries]="snapshotSummaries" class="w-full"></collection-snapshot-value-chart>
                } @else {
                    <div class="text-slate-400 italics text-center">
                        No collection data found.
                    </div>
                }
            }
        </div>
    </div>
}